/**
 * @module Module
 */
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { connect } from "react-redux";
import React from "react";

import history from "../../../Utils/History";
import PasswrdStrenthBar from "react-password-strength-bar";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import SimpleReactValidator from "simple-react-validator";
import {
  signUp,
  guestLogin,
  successfulSignUp,
  setStateParams,
} from "../../../Redux/Actions/webAppActions";

import { Text } from "react-internationalization";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";

/**
 *Reusable component used by different components for Popup's.
 * @method Modal
 * @param {object} props props that is being passed by the
 * @returns {JSX} returns Modal jsx.
 */
class RModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: "",
      email: "",
      passwrd: "",
      firstName: "",
      lastName: "",
      confrmPasswrd: "",
      showPswd: false,
      pswdEye: false,
      showConfirmPswd: false,
      confirmPswdEye: false,
      emailError: false,
      firstNameError: false,
      lastNameError: false,
      pswdError: false,
      confirmPwdEmptyError: false,
      confirmPswdError: false,
      modified: false,
      success: false,
      snackBarOpen: false,
      snackBarMsg: "",
      vertical: "top",
      horizontal: "center",
      open: "false",
      textColor: "#ef4836",
      textColor1: "#ef4836",
    };
    this.validator = new SimpleReactValidator();
  }

  /**
   * Re renders the component everytime and set's toggle.
   * @function useEffect
   * @returns {void}
   */
  componentDidMount() {
    window.scroll(0, 0);
    this.setState({
      toggle: true,
    });
  }
  onChangeScore = (scroe) => {
    this.setState({
      textColor:
        scroe === 1
          ? "#ef4836"
          : scroe === 2
          ? "#f6b44d"
          : scroe === 3
          ? "#2b90ef"
          : scroe === 4
          ? "#25c281"
          : "#ef4836",
    });
  };
  onChangeScore1 = (scroe) => {
    this.setState({
      textColor1:
        scroe === 1
          ? "#ef4836"
          : scroe === 2
          ? "#f6b44d"
          : scroe === 3
          ? "#2b90ef"
          : scroe === 4
          ? "#25c281"
          : "#ef4836",
    });
  };
  /**
   * Re renders the component whenever new props are passed.
   * @function useEffect
   * @returns {void}
   */

  handleChange = async (event) => {
    const { passwrd } = this.state;
    const name = event.target.name;
    const value = event.target.value;
    const emailError =
      name === "email" &&
      (!this.validator.check(value, "email") || value === "");
    const confirmPwdEmptyError = name === "confrmPasswrd" && value === "";
    const firstNameError = name === "firstName" && value === "";
    const lastNameError = name === "lastName" && value === "";
    const pswdError = name === "passwrd" && value === "";
    const confirmPswdError =
      name === "confrmPasswrd" && (value === "" || passwrd !== value);

    await this.setState({
      [name]: value,
      emailError: emailError,
      pswdError: pswdError,
      confirmPswdError: confirmPswdError,
      confirmPwdEmptyError: confirmPwdEmptyError,
      firstNameError: firstNameError,
      lastNameError: lastNameError,
      modified: true,
    });
  };

  handleFocus = (name) => (event) => {
    event.preventDefault();
    const showPswdEye = name === "passwrd";
    const showConfirmPswdEye = name === "confrmPasswrd";
    this.setState({
      pswdEye: showPswdEye,
      confirmPswdEye: showConfirmPswdEye,
    });
  };

  handleOnBlur = (name) => (event) => {
    event.preventDefault();
    const {
      showConfirmPswd,
      showPswd,
      email,
      passwrd,
      confrmPasswrd,
      firstName,
      lastName,
    } = this.state;
    const showPswdEye = name === "passwrd" && showPswd;
    const showConfirmPswdEye =
      name === "confrmPasswrd" && showConfirmPswd;
    const emailError =
      name === "email" &&
      (!this.validator.check(email, "email") || email === "");
    const pswdError = passwrd === "";
    const confirmPwdEmptyError =
      name === "confrmPasswrd" && confrmPasswrd === "";
    const firstNameError = name === "firstName" && firstName === "";
    const lastNameError = name === "lastName" && lastName === "";
    const confirmPswdError =
      confrmPasswrd === "" || passwrd !== confrmPasswrd;
    this.setState({
      ...this.state,
      pswdEye: showPswdEye,
      confirmPswdEye: showConfirmPswdEye,
      emailError: emailError,
      pswdError: pswdError,
      firstNameError: firstNameError,
      lastNameError: lastNameError,
      confirmPswdError: confirmPswdError,
      confirmPwdEmptyError: confirmPwdEmptyError,
    });
  };

  showPswd = (name, toggle) => (event) => {
    document.getElementById(name).focus();
    const eyeIcon = name === "passwrd" ? "pswdEye" : "confirmPswdEye";
    const show = name === "passwrd" ? "showPswd" : "showConfirmPswd";
    this.setState({
      [eyeIcon]: true,
      [show]: toggle,
    });
  };

  signUp = async (e) => {
    e.preventDefault();
    const { email, passwrd, confrmPasswrd, firstName, lastName } = this.state;

    const emailError = !this.validator.check(email, "email") || email === "";

    const confirmPswdError =
      confrmPasswrd === "" || passwrd !== confrmPasswrd;
    if (!firstName) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "Por favor, introduzca el nombre"
            : "Please enter First Name",
      });
      return;
    }
    if (!lastName) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "Por favor ingrese apellido"
            : "Please enter last Name",
      });
      return;
    }
    if (emailError) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "El formato del correo electrónico es incorrecto"
            : "Email format is incorrect",
      });
      return;
    }
    if (!passwrd) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "Por favor, ingrese contraseña"
            : "Please enter Password",
      });
      return;
    }
    let pattern = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$"
    );
    if (!pattern.test(passwrd) || passwrd.length < 8) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "¡La contraseña debe tener al menos 8 o más caracteres con una combinación de mayúsculas y minúsculas, números y caracteres especiales!"
            : "password must be atleast 8 or more characters with a mix of upper & lowercase, numbers & Special Character!",
      });
      return;
    }

    if (confirmPswdError) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "Las contraseñas no coinciden - Vuelva a ingresar"
            : "Passwords do not match - Please Re-enter",
      });
      return;
    }
    let body = {
      emailAddress: email,
      password: passwrd,
      reconfirmPwd: confrmPasswrd,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
    };
    body = { ...body, customerId: this.props?.customerId };
    const signup = await this.props.signUp(body);
    if (signup.message === "SUCCESS") {
      this.props.successfulSignUp(true);
      this.setState({
        firstName: "",
        lastName: "",
        email: "",
        passwrd: "",
        confrmPasswrd: "",
        showPswd: false,
        showConfirmPswd: false,
      });
    } else {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "El usuario ya existe. ¡Por favor regístrese con una nueva cuenta de correo electrónico!"
            : "User Already Exists. Please register with new email account !!",
      });
    }
  };

  login = (e) => {
    e.preventDefault();
    this.setState({
      emailError: false,
      firstNameError: false,
      lastNameError: false,
      pswdError: false,
      confirmPwdEmptyError: false,
      confirmPswdError: false,
    });
    this.props.RmodalClosed();
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };

  render() {
    const {
      passwrd,
      confrmPasswrd,
      email,
      showPswd,
      showConfirmPswd,
      firstName,
      lastName,
      snackBarOpen,
      snackBarMsg,
      vertical,
      horizontal,
    } = this.state;
    return (
      <>
        <Dialog
          open={this.props.show && this.state.toggle}
          id={this.props.idName ? this.props.idName : ""}
        >
          <DialogTitle class="usersignuptitle">
            {!this.props.closeIcon ? (
              <IconButton
                onClick={() => {
                  this.setState({
                    firstName: "",
                    lastName: "",
                    email: "",
                    passwrd: "",
                    confrmPasswrd: "",
                    showPswd: false,
                    showConfirmPswd: false,
                  });
                  this.props.RmodalClosed();
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
            {this.props.dialogTitle}
            {this.props.closeIcon ? (
              <a
                class="float-right cursor-pointer"
                onClick={() => {
                  this.setState({
                    firstName: "",
                    lastName: "",
                    email: "",
                    passwrd: "",
                    confrmPasswrd: "",
                    showPswd: false,
                    showConfirmPswd: false,
                  });
                  this.props.RmodalClosed();
                }}
              >
                <i class="fas fa-times" />
              </a>
            ) : (
              ""
            )}
          </DialogTitle>
          <DialogContent>
            <Snackbar
              open={snackBarOpen}
              autoHideDuration={6000}
              onClose={this.handleClose}
              anchorOrigin={{ vertical, horizontal }}
              key={vertical + horizontal}
            >
              {
                <Alert onClose={this.handleClose} severity="error">
                  {snackBarMsg}
                </Alert>
              }
            </Snackbar>
            <div class="container-Cambia container-Cambia2 mt-3 mg-footer">
              <div class="tab-content tab-content2">
                <div class="container form-panel">
                  <div class="form-group">
                    <div>
                      <div>
                        <div className="name-style">
                          <TextField
                            id="firstName"
                            label={<Text id="app.FirstName" />}
                            variant="outlined"
                            name="firstName"
                            fullWidth
                            className="width-container2"
                            error={firstName === ""}
                            type="text"
                            value={firstName}
                            onChange={this.handleChange}
                            onBlur={this.handleOnBlur("firstName")}
                            inputProps={{
                              autoComplete: "off",
                              spellcheck: "false",
                              "aria-autocomplete": "both",
                              "aria-haspopup": "false",
                            }}
                          />

                          <div className="name-style2">
                            <TextField
                              id="lastName"
                              label={<Text id="app.LastName" />}
                              variant="outlined"
                              name="lastName"
                              fullWidth
                              error={lastName === ""}
                              className="width-container2"
                              value={lastName}
                              onChange={this.handleChange}
                              onBlur={this.handleOnBlur("lastName")}
                              inputProps={{
                                autoComplete: "off",
                                spellcheck: "false",
                                "aria-autocomplete": "both",
                                "aria-haspopup": "false",
                              }}
                            />
                          </div>
                        </div>

                        <br />

                        <div class="position-relative">
                          <TextField
                            label={<Text id="user.emailAdd" />}
                            variant="outlined"
                            type="email"
                            name="email"
                            class="emailbackgroundColor"
                            fullWidth
                            error={
                              !this.validator.check(email, "email") ||
                              email === ""
                            }
                            value={email}
                            onChange={this.handleChange}
                            onBlur={this.handleOnBlur("email")}
                            inputProps={{
                              autoComplete: "off",
                              spellcheck: "false",
                              "aria-autocomplete": "both",
                              "aria-haspopup": "false",
                            }}
                          />
                        </div>
                        <br />
                        <p class="textFonts">
                          <Text id="user.textFonts" />
                        </p>

                        <div>
                          <div class="position-relative">
                            <TextField
                              label={<Text id="user.setValue" />}
                              variant="outlined"
                              class="textstyle"
                              type={showPswd ? "text" : "password"}
                              id="passwrd"
                              name="passwrd"
                              fullWidth
                              error={passwrd === ""}
                              value={passwrd}
                              onFocus={this.handleFocus("passwrd")}
                              onBlur={this.handleOnBlur("passwrd")}
                              onChange={this.handleChange}
                              inputProps={{
                                autoComplete: "new-password",
                              }}
                            />

                            {showPswd ? (
                              <div
                              class="eyeIcon-password"
                                onMouseDown={this.showPswd(
                                  "passwrd",
                                  !this.state.showPswd
                                )}
                              >
                                <RemoveRedEyeIcon className="eyeicon-m-r-9px" />
                              </div>
                            ) : (
                              <div
                              class="eyeIcon-password"
                                onMouseDown={this.showPswd(
                                  "passwrd",
                                  !this.state.showPswd
                                )}
                              >
                                <VisibilityOffIcon className="eyeicon-m-r-9px" />
                              </div>
                            )}
                          </div>
                          <div>
                            <div class="w-100">
                              {passwrd.length > 0 ? (
                                <PasswrdStrenthBar
                                  password={passwrd}
                                  scoreWordStyle={{
                                    color: this.state.textColor,
                                    fontWeight: 600,
                                    fontSize: "1rem",
                                  }}
                                  class="pwd-strength-bar"
                                  minLength={8}
                                  onChangeScore={this.onChangeScore}
                                />
                              ): (
                                ""
                              )}
                            </div>

                            <div class="position-relative m-top-2em">
                              <TextField
                                label={<Text id="user.confVal" />}
                                variant="outlined"
                                class="textstyle"
                                type={showConfirmPswd ? "text" : "password"}
                                id="confrmPasswrd"
                                fullWidth
                                name="confrmPasswrd"
                                error={
                                  confrmPasswrd === "" ||
                                  passwrd !== confrmPasswrd
                                }
                                value={confrmPasswrd}
                                onFocus={this.handleFocus("confrmPasswrd")}
                                onBlur={this.handleOnBlur("confrmPasswrd")}
                                onChange={this.handleChange}
                                inputProps={{
                                  autoComplete: "off",
                                  spellcheck: "false",
                                  "aria-autocomplete": "both",
                                  "aria-haspopup": "false",
                                }}
                              />
                              {showConfirmPswd ? (
                                <div
                                class="eyeIcon-confirm-password"
                                  onMouseDown={this.showPswd("confrmPasswrd", !this.state.showConfirmPswd
                                  )}
                                >
                                  <RemoveRedEyeIcon
                                    className="eyeicon-m-r-9px"
                                    onClick={this.showPswd}
                                  />
                                </div>
                              ) : (
                                <div
                                class="eyeIcon-confirm-password"
                                  onMouseDown={this.showPswd("confrmPasswrd", !this.state.showConfirmPswd
                                  )}
                                >
                                  <VisibilityOffIcon className="eyeicon-m-r-9px" />
                                </div>
                              )}
                            </div>
                          </div>
                          <div>
                            <div class="w-100">
                              {confrmPasswrd.length > 0 ? (
                                <PasswrdStrenthBar
                                  password={confrmPasswrd}
                                  scoreWordStyle={{
                                    color: this.state.textColor1,
                                    fontWeight: 600,
                                    fontSize: "1rem",
                                  }}
                                  class="pwd-strength-ba"
                                  minLength={8}
                                  onChangeScore={this.onChangeScore1}
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="button-container-login-page">
                      <div class="row">
                        <div class="col-md-8">
                          <div class="already-have-account">
                            <p>
                              <Text id="user.already" /> <br />
                              <a href="#none" onClick={this.login}>
                                <Text id="user.log" />
                              </a>
                            </p>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <button
                            class="btn-primary-continue"
                            id="signup"
                            onClick={this.signUp}
                            disabled={!this.state.modified}
                          >
                            <Text id="user.sign" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    email: state.login.emailAddress,
    lang: state.webApp.language,
    successignUp: state.login.successfulSignUp,
    customerId: state.login.customerId,
  };
};
const mapDispatchToProps = {
  signUp,
  guestLogin,
  successfulSignUp,
  setStateParams,
};

export default connect(mapStateToProps, mapDispatchToProps)(RModal);
